module.exports = __webpack_public_path__ + "static/media/check-circle-kuara.4e564687.svg";